import {randomFromArray} from '../../../helpers/random-from-array.js'
import {getSelfServingTeamOrder} from '../get-sorted-by-self-serving'

export function getBoostingPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  //See if we have valid recovery moves
  const validMoves = getValidBoostingMoves(casterActions);
  if (!validMoves.length) {
    return null
  }

  //Pick the action
  const actionModel = randomFromArray(validMoves);

  //If this affects all teammates, just do it.
  if (actionModel.targetType === "ally-team") {
    return {
      actionModel: actionModel,
      casterModel: casterModel,
      targetModels: teamCombatants
    }
  }

  //If this is a SINGLE TARGET stat booster (not a status changer), pick a friendly target by selfServingOrder
  if (isStatBoostingAction(actionModel)) {
    return {
      actionModel: actionModel,
      casterModel: casterModel,
      targetModels: [
        getSelfServingTeamOrder(casterModel, teamCombatants)[0]
      ]
    }
  }


  //Status changer that requires single target identification...
  //Choose a valid person to recover (uses selfServing)
  const targetModel = confirmBoostingTarget(
    getSelfServingTeamOrder( casterModel, teamCombatants )
  );

  //Return a random one of our valid moves
  if (targetModel) {
    return {
      actionModel: actionModel,
      casterModel: casterModel,
      targetModels: [targetModel]
    }
  }

  return null
}



function confirmBoostingTarget(remainingTargets) {

  //check the first in the list
  const candidate = remainingTargets[0];
  if (candidate.status === "normal" && candidate.isAlive()) {
    return candidate
  }

  if (remainingTargets.length > 1) {
    return confirmBoostingTarget( remainingTargets.filter((d,i) => i > 0 )); //run again without the 0th entry
  }

  //nobody is valid
  return null
}

function isStatBoostingAction(actionModel) {

  if (actionModel.affectTargetStatus) {
    return false;
  }

  return (
    actionModel.affectTargetDangerMeter > 0 || //Danger Meter is considered a "stat" for boosting
    actionModel.affectTargetAttackModifier > 0 ||
    actionModel.affectTargetDefenseModifier > 0 ||
    actionModel.affectTargetSpeedModifier > 0
  )
}

function getValidBoostingMoves(casterActions) {
  return casterActions.filter(action => {

    //Check for moves that boost stats
    if (isStatBoostingAction(action)) {
      return true
    }

    //Now rule out anything that isn't a status changer
    if (!action.affectTargetStatus) {
      return false
    }

    const resultingStatus = action.affectTargetStatus[1];

    //Add these as needed
    return [
        "fury",
        "focus",
        "deadline"
        //insert more positive statuses here
      ].indexOf(resultingStatus) > -1;
  });
}



// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-boosting-path.js